export default "__VITE_ASSET__Cp41tgw6__"